import React from 'react';
import { LandingPage } from './pages/LandingPage';
export function App() {
  return <LandingPage data-id="element-0" data-mp="35cbw8bxnfr67" />;
}